"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationDtoFactory = void 0;
var offering_dto_1 = require("../offerings/offering.dto");
var DurationDtoFactory = /** @class */ (function () {
    function DurationDtoFactory() {
    }
    DurationDtoFactory.fromOfferingDto = function (offeringDto) {
        return {
            startDate: offeringDto.schedule.startDate,
            durationInMinutes: DurationDtoFactory.durationInMinutesFromOffering(offeringDto),
            isDurationVaries: DurationDtoFactory.isDurationVariesFromOffering(offeringDto),
        };
    };
    DurationDtoFactory.durationInMinutesFromOffering = function (offeringDto) {
        if (offeringDto.type === offering_dto_1.OfferingType.INDIVIDUAL ||
            offeringDto.type === offering_dto_1.OfferingType.DUMMY ||
            offeringDto.type === offering_dto_1.OfferingType.GROUP) {
            var schedule = offeringDto.schedule;
            return schedule.durationInMinutes;
        }
        return 0;
    };
    DurationDtoFactory.isDurationVariesFromOffering = function (offeringDto) {
        if (offeringDto.type === offering_dto_1.OfferingType.GROUP) {
            var schedule = offeringDto.schedule;
            return schedule.isDurationVaries;
        }
        return false;
    };
    return DurationDtoFactory;
}());
exports.DurationDtoFactory = DurationDtoFactory;
//# sourceMappingURL=duration-dto-factory.js.map